export function toKeyIndexedObject<T>(arr: T[], keyExtractor: (a: T) => string): { [key: string]: T } {
	return arr.reduce((obj: { [key: string]: T }, a: T) => {
		obj[keyExtractor(a)] = a;
		return obj;
	}, {});
}

export function arrayMove<T>(collection: T[], previousIndex: number, newIndex: number, createNewReference = true): T[] {
	let newArray = collection;
	if (createNewReference) {
		newArray = [...collection]
	}
	newArray.splice(newIndex, 0, newArray.splice(previousIndex, 1)[0]);
	return newArray
}